import React, { Component } from 'react';
import { ContextApi } from './ContextApi'

class AppProvider extends Component{
state = { 
    name: "Jude",
    "year": new Date().getFullYear(),
     time: new Date().toLocaleDateString()
    }
   render(){
      return(
            <ContextApi.Provider value={{ state:this.state }}>
                {this.props.children}
            </ContextApi.Provider>
        )
    }
};

export { AppProvider }


// WEBPACK FOOTER //
// ./src/components/context/AppProvider.js